import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';

const LogoutPage = function LogoutPage() {
  const { logout } = useAuth();
  logout();
  return <Navigate to="/" replace />;
};
export default LogoutPage;
